import React from "react";
import { Footer } from "./components/Footer/Footer";
import { Header } from "./components/Header/Header";
import VehiculosProvider from "./context/VehiculosContext";

import "./assets/scss/styles.scss";
import WhatsAppFlotante from "./components/WhatsAppFlotante/WhatsAppFlotante";

export const App = () => {
  return (
    <VehiculosProvider>
      <Header />
      <Footer />
      <WhatsAppFlotante />
    </VehiculosProvider>
  );
};
